import { createApp } from "@studiometa/js-toolkit";
import { Playground } from "./components/Playground.js";
import { setConfig } from "./store/config.js";
function createPlayground(config) {
  setConfig(config);
  return createApp(Playground);
}
export {
  createPlayground
};
//# sourceMappingURL=create-playground.js.map
